import React from 'react';

import { BulkActionProps } from 'react-admin';

import { StintCancelStintsButton } from '../StintCancelStintsButton';

export const StintListActions: React.FC<BulkActionProps> = props => (
  <StintCancelStintsButton {...props} />
);
